import { cn } from '@/lib/utils'
import type { PriorityStatus } from '@/types'

const CONFIG: Record<PriorityStatus, { label: string; className: string }> = {
  aspirational: {
    label: 'Aspirational',
    className: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800',
  },
  active: {
    label: 'Active',
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800',
  },
  dormant: {
    label: 'Resting',
    className: 'bg-muted text-muted-foreground border-border',
  },
  completed: {
    label: 'Completed',
    className: 'bg-teal-50 text-teal-700 border-teal-200 dark:bg-teal-950/40 dark:text-teal-300 dark:border-teal-800',
  },
  released: {
    label: 'Released',
    className: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800',
  },
}

interface PriorityStatusBadgeProps {
  status: PriorityStatus
  className?: string
}

export function PriorityStatusBadge({ status, className }: PriorityStatusBadgeProps) {
  const { label, className: statusClass } = CONFIG[status]
  return (
    <span
      className={cn(
        'inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium border',
        statusClass,
        className,
      )}
    >
      {label}
    </span>
  )
}

export { CONFIG as STATUS_CONFIG }
